/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortfolioTypeRule } from './PortfolioTypeRule';
import {
    PortfolioTypeRuleFromJSON,
    PortfolioTypeRuleFromJSONTyped,
    PortfolioTypeRuleToJSON,
    PortfolioTypeRuleToJSONTyped,
} from './PortfolioTypeRule';

/**
 * 
 * @export
 * @interface PortfolioRulesResponse
 */
export interface PortfolioRulesResponse {
    /**
     * Portfolio types allowed for the business relationship; empty when no portfolio is allowed.
     * @type {Array<PortfolioTypeRule>}
     * @memberof PortfolioRulesResponse
     */
    portfolioTypes: Array<PortfolioTypeRule>;
    /**
     * Cash accounts not linked to a portfolio may be created for this business relationship.
     * @type {boolean}
     * @memberof PortfolioRulesResponse
     */
    brLevelCashAccountAllowed: boolean;
}

/**
 * Check if a given object implements the PortfolioRulesResponse interface.
 */
export function instanceOfPortfolioRulesResponse(value: object): value is PortfolioRulesResponse {
    if (!('portfolioTypes' in value) || value['portfolioTypes'] === undefined) return false;
    if (!('brLevelCashAccountAllowed' in value) || value['brLevelCashAccountAllowed'] === undefined) return false;
    return true;
}

export function PortfolioRulesResponseFromJSON(json: any): PortfolioRulesResponse {
    return PortfolioRulesResponseFromJSONTyped(json, false);
}

export function PortfolioRulesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioRulesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'portfolioTypes': ((json['portfolioTypes'] as Array<any>).map(PortfolioTypeRuleFromJSON)),
        'brLevelCashAccountAllowed': json['brLevelCashAccountAllowed'],
    };
}

export function PortfolioRulesResponseToJSON(json: any): PortfolioRulesResponse {
    return PortfolioRulesResponseToJSONTyped(json, false);
}

export function PortfolioRulesResponseToJSONTyped(value?: PortfolioRulesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'portfolioTypes': ((value['portfolioTypes'] as Array<any>).map(PortfolioTypeRuleToJSON)),
        'brLevelCashAccountAllowed': value['brLevelCashAccountAllowed'],
    };
}

